import { CancelToken } from 'api';
import { get } from 'features/api';
import { RegionsStoresResponse } from './types';

export function fetchStoresAndRegions(cancelToken?: CancelToken) {
  return get<RegionsStoresResponse>('get-regions-and-stores', {}, { cancelToken });
}
